import { actions } from './action'

const initialState = {
  teamList: [],
  totalCount: 0,
  empList: [],
  teams: [],
  teamData: {
    amList: [],
    managerList: [],
    tlList: [],
  },
  pagination: {
    skip: 0,
    limit: 10,
  },
  searchedTeam: null,
  isActive: 1,
}
const teams = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_TEAM_MEMBER:
      return {
        ...state,
        teamData: {
          amList: action.payload.amList,
          managerList: action.payload.managerList,
          tlList: action.payload.tlList,
        },
      }

    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.GET_TEAM_EMP_LIST:
      return {
        ...state,
        empList: action.payload,
      }
    case actions.HANDLE_SEARCHED_TEAM:
      return {
        ...state,
        searchedTeam: action.payload,
      }

    case actions.GET_TEAM_LIST:
      return {
        ...state,
        teamList: action.payload.teamList,
        totalCount: action.payload.totalCount,
        teams: action.payload.teams,
      }

    default:
      return state
  }
}
export default teams
